import { useTranslation } from "react-i18next";
import { NavLink } from "../../app/NavBar/NavBarElements";
import { ReactElement } from "react";
import { useLocation } from "react-router-dom";
import { conditionallyHighlighted } from "../../../utils/cssUtils";

const ActionReportLink = (): ReactElement => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  return (
    <NavLink
      to="/akcije/izvjestaj"
      highlighted={conditionallyHighlighted(pathname, "/akcije/izvjestaj")}
    >
      {t("report")}
    </NavLink>
  );
};

export default ActionReportLink;
